module.exports = __webpack_public_path__ + "static/img/1.cbd63d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R600A/1.jpg
// module id = 9nuE
// module chunks = 1